require('./azurebackup.style.scss');
require('./azurebackup.views.common.style.scss');

const angularModule = angular.module('com.comtrade.azureCloud.backup', [require('./components/components.module').name,
require('../shared/shared.module').name,
require('./views/mainApp/mainApp.module').name,
require('./views/virtualMachines/virtualMachines.module').name,
require('./views/policies/policies.module').name,
require('./views/dashboard/components/components.module').name,
require('./views/targets/targets.module').name,
require('./views/events/events.module').name,
require('./views/tasks/tasks.module').name,
require('./views/reports/reports.module').name,
require('./views/registration/registration.module').name,
    'ui.router',
    'ngSanitize',
    'ngCookies',
    'ngStorage',
    'ngAnimate',
    'angular-busy',
    'gridster',
    'toaster'
]);

angularModule.run(['$rootScope', '$state', '$stateParams', 'authorizationService', 'principalService', 'utilsService',
    function ($rootScope, $state, $stateParams, authorizationService, principalService, utilsService) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
            $rootScope.toState = toState;
            $rootScope.toStateParams = toStateParams;
            // let lang = toStateParams && toStateParams.lang ?
            // (toStateParams.lang.toUpperCase() === 'EN' || toStateParams.lang.toUpperCase() === 'JP') ? toStateParams.lang : 'EN' : null;
            let lang = 'EN';
            if (principalService.isIdentityResolved()) authorizationService.authorize();
            utilsService.reloadTranslateData(lang).then(() => {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
            });
        }

        );
    }

]);

angularModule.constant('config', require('./app.constants'));

angularModule.component('login', require('./views/login/login.component'));
angularModule.component('tenantDialog', require('./views/login/dialogs/tenantDialog/tenantDialog.component'));
angularModule.component('accessDenied', require('./views/accessDenied/accessDenied.component.js'));
angularModule.component('dashboard', require('./views/dashboard/dashboard.component'));
angularModule.service('loginService', require('./services/login.service'));
angularModule.service('principalService', require('./services/principal.service'));
angularModule.service('authorizationService', require('./services/authorization.service'));
angularModule.service('storageService', require('./services/storage.service'));
angularModule.service('crudService', require('./services/crud.service'));
angularModule.service('styleService', require('./services/style.service'));
angularModule.service('utilsService', require('./services/utils.service'));
angularModule.service('iamPersistenceService', require('./services/iam.persistence.service'));
angularModule.service('validationsService', require('./services/validations.service'));

angularModule.service('sseService', require('./services/sse.service'));
angularModule.service('sharedPersistenceService', require('./services/shared.persistence.service'));
angularModule.service('docsService', require('./services/docs.service'));
angularModule.service('logoutService', require('./services/logout.service'));
angularModule.service('gridsterPositions', require('./services/gridsterPositions.service'));

angularModule.filter('localizeDate', require('./filters/localizeDate.filter'));
angularModule.filter('fileTypes', require('./filters/fileTypes.filter'));

angularModule.config(require('./states.config')).config(require('./angularBusy.config'));

module.exports = angularModule;


// WEBPACK FOOTER //
// ./src/azurebackup/azurebackup.app.js